/* eslint-disable camelcase */
export type UserDetailsQuery = {
  email: string;
  role: string;
  store_roles?: string[];
};

export enum AdminRoles {
  Admin = 'admin',
  Internal = 'internal',
  Service = 'service'
}

export enum UserRoles {
  User = 'user'
}

export enum AdminStoreRoles {
  Admin = 'admin',
  Manager = 'manager',
  Owner = 'owner'
}

export enum UserStoreRoles {
  Analytics = 'analytics',
  Follower = 'follower'
}

export type CombinedRoles = AdminRoles | UserRoles;
export type CombinedStoreRoles = AdminStoreRoles | UserStoreRoles;

export type UserDetails = {
  email: string;
  role: CombinedRoles;
  storeRoles?: CombinedStoreRoles[];
};

export type UserQueryParam = {
  storeSlug?: string;
};
